export default __webpack_public_path__ + "static/media/undraw_reading.12e08a30.svg";